import React from "react";
import { SegmentedControl } from "@mantine/core";
import { QR } from "../theme";

// Same reasoning as PurpleSwitch — force the exact brand purple on the
// active segment instead of Mantine's default (unstyled/white) active pill.
const PurpleSegmented = (props) => (
  <SegmentedControl
    {...props}
    radius={10}
    styles={{
      root: { background: QR.surface, border: `1px solid ${QR.line}`, padding: 4, gap: 2 },
      indicator: { backgroundColor: QR.purple },
      // Mantine's own .controlActive sits on top of (higher z-index than) the
      // indicator above and defaults to an opaque white background — that
      // was completely hiding the purple indicator underneath, which is why
      // the "active" segment rendered white instead of purple.
      controlActive: { backgroundColor: "transparent" },
      label: {
        padding: "6px 13px",
        borderRadius: 7,
        fontSize: 12.5,
        fontWeight: 600,
        color: QR.muted,
        fontFamily: "Inter",
        "&[data-active]": { color: "#fff" },
      },
    }}
  />
);

export default PurpleSegmented;
